import { render, staticRenderFns } from "./SjcpXq.vue?vue&type=template&id=46dfb2f0&scoped=true&"
import script from "./SjcpXq.vue?vue&type=script&lang=js&"
export * from "./SjcpXq.vue?vue&type=script&lang=js&"
import style0 from "./SjcpXq.vue?vue&type=style&index=0&id=46dfb2f0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dfb2f0",
  null
  
)

export default component.exports